import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

export default function PageHeader({ title, description }) {
  return (
    <div className="header-wrapper">
      <Heading>{title}</Heading>
      {!!description && description !== title && <Subheading>{description}</Subheading>}
    </div>
  );
}

const Heading = styled.h1`
  margin-top: 0;
  margin-bottom: 32px;
  font-size: 28px;
  font-weight: 600;
  &:not(:last-child) {
    margin-bottom: 8px;
  }
`;

const Subheading = styled.h3`
  color: ${props => props.theme.typography.color.minor};
  font-weight: normal;
  margin: 0 0 32px 0;
  opacity: 0.7;
`;

PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};
